import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../../configs/api";
import ProductCard, { ProductSkeleton } from "../../common/ProductCard";
import Button from "../Common/Button";
import { useCart } from "../../../context/CartContext";

export default function MixMastersProducts() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const fetchProducts = async () => {
    try {
      setLoading(true);

      const res = await api.get("/products?page=1&limit=8");
      const { products } = res.data.data;

      setProducts(products);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect(); // stop observing
        }
      },
      { threshold: 0.2 },
    );

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <div ref={ref} className="w-full bg-white">
      <div className="products-section px-4 md:px-8 lg:px-10">
        {/* Label */}
        <div
          className="text-center mb-3 transition-all duration-700"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(-10px)",
          }}
        >
          <span
            className="text-xs font-medium tracking-widest uppercase"
            style={{ color: "#c020d0", letterSpacing: "0.2em" }}
          >
            [PRODUCTS]
          </span>
        </div>

        {/* Heading */}
        <h2
          className="text-center text-2xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wider text-[#041122] font-heading leading-relaxed font-semibold md:mb-10 mb-6 transition-all duration-700"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(-20px)",
          }}
        >
          Smart Products Built for Efficiency
        </h2>

        {/* PRODUCTS GRID */}
        <div className="grid md:grid-cols-4 gap-y-8 gap-x-4 mb-10">
          {loading
            ? Array.from({ length: 8 }).map((_, i) => (
                <ProductSkeleton key={i} />
              ))
            : products.map((product, index) => (
                <ProductCard
                  key={product._id}
                  index={index}
                  product={product}
                  visible={visible}
                  onAddToCart={addToCart}
                />
              ))}
        </div>

        {/* BUTTON */}
        <div
          onClick={() => {
            navigate(`/products`);
            window.scrollTo({ top: "0", behavior: "smooth" });
          }}
          className="flex justify-center transition-all duration-700"
          style={{
            opacity: visible ? 1 : 0,
            transform: visible ? "translateY(0)" : "translateY(10px)",
          }}
        >
          <Button text="View All" />
        </div>
      </div>
    </div>
  );
}
